import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, } from 'react';
import axios from 'axios';
import { Typography } from '@mui/material';


const Makeconsultation = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const fetchConsultationById = async () => {
        try {
            const response = await axios.get(
                `https://backend.tailors4u.com/Consultation/getConsultationsById/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const payment = response?.data?.data?.payments;

            if (payment?.status === "Pending" && payment?.payment_link) {
                window.location.href = payment.payment_link;
            } else {
                console.log("No pending payment found");
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchConsultationById();
    }, []);

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <Typography>
                Redirect to payment link....
            </Typography>
        </div>
    )
}

export default Makeconsultation